<script setup lang="ts">
import { LoadStatus } from "@/models/frontend-only/LoadStatus";

const store = useSongStore();

const shown = computed(() => {
  if (
    store.status === LoadStatus.Ready &&
    store.song?.products.general.authorized &&
    !store.song?.themes?.length
  ) {
    return false;
  }
  return true;
});
</script>

<template>
  <section v-if="shown">
    <SectionTitle :placeholder="store.placeholderNotLoaded">{{
      $t("S.LIT_Themes")
    }}</SectionTitle>
    <div v-if="store.placeholderNotAuthorized">
      <span
        class="placeholder me-3"
        style="width: 100px; height: 20px; border-radius: 0.25em"
      />
      <span
        class="placeholder me-3"
        style="width: 100px; height: 20px; border-radius: 0.25em"
      />
      <span
        class="placeholder me-3"
        style="width: 100px; height: 20px; border-radius: 0.25em"
      />
      <span
        class="placeholder me-3"
        style="width: 100px; height: 20px; border-radius: 0.25em"
      />
    </div>

    <div v-else>
      <ThemeTag
        v-for="(t, i) of store.data?.themes"
        :key="i"
        :value="t"
      />
    </div>
  </section>
</template>

<style scoped lang="postcss"></style>
